module.exports = __webpack_public_path__ + "img/banner-techology-platform.1941d03d.png";